import { InternalAxiosRequestConfig } from 'axios';
import { getUser } from './getUser';
import { getUserManager } from './userManager';

export const applyAuthTokenHeader = async (
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> => {
  const manager = getUserManager();
  const user = manager ? await manager.getUser() : getUser();
  const access_token = user?.access_token;

  if (!access_token) {
    console.warn(`Making request ${config.url} without user session`);
    config.headers.delete('Authorization');
    return config;
  }

  config.headers['Authorization'] = `Bearer ${access_token}`;
  return config;
};
